import {Utils} from '../../app.base'

/** 系统上下文字段 */
export function getSysCtxFields() {
    return [{
        'name': 'realMerchantId',
        'value': '实体商户ID'
    }, {
        'name': 'merchantType',
        'value': '商户类型'
    }, {
        'name': 'merchantId',
        'value': '分管商户ID'
    }, {
        'name': 'bizUnitId',
        'value': '业务单元ID'
    }, {
        'name': 'bizOrgId',
        'value': '业务机构ID'
    }, {
        'name': 'departId',
        'value': '部门ID'
    }, {
        'name': 'staffId',
        'value': '员工ID'
    }, {
        'name': 'userId',
        'value': '用户ID'
    }, {
        'name': 'phoneNo',
        'value': '用户手机号'
    }, {
        'name': 'realComId',
        'value': '实体公司ID'
    }, {
        'name': 'devcGroupId',
        'value': '设备分组ID'
    }];
}

//解析枚举映射表达式，格式：name,type，比如 assetNature,value2text
export function parseEnumMapExpr(enumMapExpr) {
    if (enumMapExpr == null) {
        return null;
    }
    enumMapExpr = enumMapExpr.trim();
    if (enumMapExpr.length == 0) {
        return null;
    }
    var parts = enumMapExpr.split(',');
    var name = parts[0].trim();
    if (name.length == 0) {
        return null;
    }
    var type = parts.length > 1 ? parts[1].trim() : null;
    type = type || 'value2text';
    return {
        name: name,
        type: type
    };
}

//
export function makeTagMetaRoleList() {
    return [{
        'label': '基表标签',
        'value': 1
    }, {
        'label': '上游标签',
        'value': 2
    }, {
        'label': '业务标签',
        'value': 3
    }];
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/query/Cmn.js
// module id = 181
// module chunks = 1